<ng-content select="accordion-panel">
</ng-content>